import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import _ from "lodash";
import moment from "moment";
import { Subscription } from "rxjs";
import { environment } from "@env";

import { StateService } from "@services/shared/state-service";
import { TestToolService } from "../test-tool.service";
import { DEFAULT_TIMEOUT } from "@constant";
import { HelperService } from "@services/helper.service";
import { Router } from "@angular/router";
import { ToolService } from "@services/tool.service";
import {
	TOOL_STATUS,
	TOOL_STATUES,
	TOOL_STATUS_REASONS,
	TOOL_STATUS_REASON,
	TOOL_CERT_STATUES,
} from "../../../../../constants/tools.constants";

import { first, finalize } from "rxjs/operators";
import { GET_ENDPOINT_WEB, WEB_ENDPOINT } from "@constants/http-call.constants";
import { RevertStorageLocationModal } from "../../../../components/modals/RevertStorageLocationModal/RevertStorageLocationModal.component";
import { EncryptionService } from "@services/encryption.service";

@Component({
	selector: "tool-details",
	templateUrl: "./details.component.html",
	styleUrls: ["./details.component.scss"],
})
export class TestToolDetailsComponent implements OnInit {
	// Constants
	TOOL_STATUES: Array<Object> = TOOL_STATUES;
	TOOL_STATUS_REASONS = TOOL_STATUS_REASONS;
	TOOL_CERT_STATUES = TOOL_CERT_STATUES;
	WEB_ENDPOINT = WEB_ENDPOINT;
	lodash = _;
	subscriptions: Array<Subscription> = [];

	//  searching

	input_searching = false;

	searchOptions: any = {
		uom_object: null,
		person_in_charge_object: null,
		vendor: null,
	};

	// variable
	testTool: any = {};

	fields_title = {
		equipment_description: "Equipment Description",
		model: "Model",
		brand: "Brand",
		serial_no: "Serial No",
	};

	error_description = {
		description: "is required",
	};

	revertPermission = false;
	is_edit_tool = false;
	isInit = false;

	isCertSectionCollapse = false;
	certFiles = [];

	constructor(
		private activatedRoute: ActivatedRoute,
		public testToolService: TestToolService,
		private stateService: StateService,
		private helperService: HelperService,
		private router: Router,
		private toolService: ToolService,
		private encryptionService: EncryptionService // private revertModal: RevertStorageLocationModal
	) {
		this.stateService.pageInfo.next({
			title: "TEST TOOL",
			icon: environment.ASSET_PATH + "/assets/icons/service-order.png",
		});
	}

	ngOnInit() {
		this.activatedRoute.params.subscribe((params) => {
			let id = this.encryptionService.decrypt(params["id"]);
			let masterApiTotalCount = 0;
			let masterApiRunningCount = 0;

			let isInitCalled = false;
			let checkSaveInterval = setInterval(() => {
				if (
					!isInitCalled &&
					masterApiRunningCount >= masterApiTotalCount
				) {
					isInitCalled = true;
					id ? this.initTestTool() : this.initNewTestTool();
					clearInterval(checkSaveInterval);
				}
			}, 500);
		});

		this.checkRevertPermission();
	}

	ngOnDestroy() {
		_.forEach(this.subscriptions, (v) => v.unsubscribe());
	}

	private initNewTestTool() {
		this.is_edit_tool = false;
		// console.log("initNewTestTool()");
		let statusReason = _.chain(TOOL_STATUS_REASONS)
			.cloneDeep()
			.filter({ value: TOOL_STATUS_REASON.DRAFT })
			.head()
			.value();
		let newTool: any = {
			status: _.get(statusReason, "status"),
			status_reason: _.get(statusReason, "value"),
		};

		this.testTool = _.cloneDeep(newTool);
	}

	initTestTool() {
		this.is_edit_tool = true;
		// console.log("initTestTool()");
		const id = this.activatedRoute.snapshot.paramMap.get("id")
			? this.activatedRoute.snapshot.paramMap.get("id")
			: this.testTool.id;

		this.subscriptions.push(
			this.testToolService
				.get(this.encryptionService.decrypt(id), {
					edges: "cert_files",
				})
				.pipe(first())
				.subscribe(async (response: any) => {
					let tempTestTool = _.get(response, "data", {});
					let dateOfPurchase = moment(tempTestTool.date_of_purchase);
					let latestCertDate = moment(
						tempTestTool.latest_calibration_date
					);
					let latestCalExp = moment(
						tempTestTool.latest_calibration_expiry
					);
					let nextCal = moment(tempTestTool.next_calibration);

					tempTestTool = {
						...tempTestTool,
						date_of_purchase:
							tempTestTool.date_of_purchase &&
							dateOfPurchase.isValid()
								? dateOfPurchase.toDate()
								: null,
						latest_calibration_date:
							tempTestTool.latest_calibration_date &&
							latestCertDate.isValid()
								? latestCertDate.toDate()
								: null,
						latest_calibration_expiry:
							tempTestTool.latest_calibration_expiry &&
							latestCalExp.isValid()
								? latestCalExp.toDate()
								: null,
						next_calibration:
							tempTestTool.next_calibration && nextCal.isValid()
								? nextCal.toDate()
								: null,
					};

					this.testTool = _.cloneDeep(tempTestTool);

					if (
						this.testTool.vendor.id === null ||
						this.testTool.vendor.id === undefined
					) {
						this.testTool.vendor = null;
					}

					this.certFiles = _.get(this.testTool, "cert_files", []);
					this.helperService.initializeSearchingOptions(
						this.testTool,
						this.searchOptions
					);
				})
		);
	}

	getSaveValidationMessages() {
		let invalidFieldMessage = [];

		if (_.isEmpty(this.testTool.equipment_description)) {
			invalidFieldMessage.push(
				this.fields_title.equipment_description +
					" " +
					this.error_description.description
			);
		}
		if (_.isEmpty(this.testTool.model)) {
			invalidFieldMessage.push(
				this.fields_title.model +
					" " +
					this.error_description.description
			);
		}
		if (_.isEmpty(this.testTool.brand)) {
			invalidFieldMessage.push(
				this.fields_title.brand +
					" " +
					this.error_description.description
			);
		}

		return invalidFieldMessage;
	}

	saveToolInfo(formRef: NgForm) {
		_.each(formRef.controls, (formControlRef, index) => {
			formControlRef.markAsDirty();
		});

		let invalidFieldMessage = this.getSaveValidationMessages();
		if (invalidFieldMessage.length > 0) {
			this.helperService.errorMessage(invalidFieldMessage[0]);
			return;
		}

		let date_of_purchase = this.testTool.date_of_purchase
			? moment(this.testTool.date_of_purchase)
			: null;
		let latest_calibration_date = this.testTool.latest_calibration_date
			? moment(this.testTool.latest_calibration_date)
			: null;
		let latest_calibration_expiry = this.testTool.latest_calibration_expiry
			? moment(this.testTool.latest_calibration_expiry)
			: null;
		let next_calibration = this.testTool.next_calibration
			? moment(this.testTool.next_calibration)
			: null;
		let vendor_account =
			_.get(this.testTool, "vendor.external_id") != null
				? _.get(this.testTool, "vendor.external_id")
				: null;

		let form_data = {
			...this.testTool,
			uom: _.get(this.testTool, "uom_object.symbol"),
			person_in_charge: _.get(
				this.testTool,
				"person_in_charge_object.external_id"
			),
			date_of_purchase:
				date_of_purchase && date_of_purchase.isValid()
					? date_of_purchase.format("YYYY-MM-DD")
					: null,
			latest_calibration_date:
				latest_calibration_date && latest_calibration_date.isValid()
					? latest_calibration_date.format("YYYY-MM-DD")
					: null,
			latest_calibration_expiry:
				latest_calibration_expiry && latest_calibration_expiry.isValid()
					? latest_calibration_expiry.format("YYYY-MM-DD")
					: null,
			next_calibration:
				next_calibration && next_calibration.isValid()
					? next_calibration.format("YYYY-MM-DD")
					: null,
			vendor_account: vendor_account,
		};

		form_data = _.omit(form_data, [
			"uom_object",
			"person_in_charge_object",
		]);

		if (!this.is_edit_tool) {
			let tempSubscription = this.testToolService
				.createNewTestTool(form_data)
				.subscribe(async (response: any) => {
					let tempTool = _.get(response, "data");
					await this.router.navigateByUrl(
						GET_ENDPOINT_WEB(
							WEB_ENDPOINT.TEST_TOOL_DETAILS,
							tempTool.id
						),
						{ replaceUrl: true }
					);
					this.testTool = _.cloneDeep(tempTool);

					// this.initTestTool();
					this.helperService.successMessage(response.message);
					tempSubscription.unsubscribe();
				});
		} else {
			let tempSubscription = this.testToolService
				.update(this.testTool.id, form_data)
				.subscribe(async (response: any) => {
					let tempTool = _.get(response, "data");
					this.testTool = _.cloneDeep(tempTool);
					this.initTestTool();
					this.helperService.successMessage(response.message);
					tempSubscription.unsubscribe();
				});
		}
	}

	onChangeStatusReason() {
		let statusReason = _.chain(TOOL_STATUS_REASONS)
			.filter({ value: this.testTool.status_reason })
			.head()
			.value();
		this.testTool.status = statusReason.status;
	}

	deleteSuccess() {
		this.router.navigateByUrl(WEB_ENDPOINT.TEST_TOOL_LISTING, {
			replaceUrl: true,
		});
	}

	// searching feature start
	// Searching Options
	onSearchOptions(event, id, url, fields, differenceBy = "id") {
		this.helperService.onSearchOptions(event, id, url, fields, this);
	}
	// searching feature end

	cancelTools() {
		let params = {
			status_reason: TOOL_STATUS_REASON.CANCELLED_DATA_ENTRY_LINE,
			tool_ids: _.map([this.testTool], "id"),
		};

		let tempSubscription = this.testToolService
			.changeStatus(params)
			.subscribe((response: any) => {
				this.helperService.toastMessage("success", response.message);
				this.initTestTool();
				tempSubscription.unsubscribe();
			});
	}

	updateUploadedFiles({ uploadedFiles }) {
		this.certFiles = [...this.certFiles, ...uploadedFiles];
	}

	deleteFile({ file }) {
		// console.log(file);
		let params = {
			tool: this.testTool,
			file: file,
		};

		let tempSubscription = this.toolService
			.deleteToolCertificationFile(params)
			.subscribe((response: any) => {
				this.helperService.toastMessage("success", response.message);
				this.certFiles = _.remove(this.certFiles, (item) => {
					return item.id != file.id;
				});
				tempSubscription.unsubscribe();
			});
	}

	onChangeVendorAccount(event) {
		let vendor_account = event.value;

		if (!vendor_account) {
			this.testTool.contact_number = "";
			this.testTool.email = "";
			return;
		}

		if (!_.isEmpty(vendor_account.phone)) {
			this.testTool.contact_number = _.cloneDeep(vendor_account.phone);
		}

		if (!_.isEmpty(vendor_account.email)) {
			this.testTool.email = _.cloneDeep(vendor_account.email);
		}
	}

	checkRevertPermission() {
		let tempSubscription = this.testToolService
			.checkRevertLocationPermission()
			.subscribe((response: any) => {
				if (response["message"] === "Allowed") {
					this.revertPermission = true;
				}
				tempSubscription.unsubscribe();
			});
	}

	handleRevertLocation(dataList: string[]) {
		let storageLocID = dataList["id"];
		if (dataList != null) {
			let params = {
				location_id: storageLocID,
				tool_id: this.testTool.id,
			};
			let tempSubscription = this.testToolService
				.revertLocation(params)
				.subscribe((response: any) => {
					this.helperService.toastMessage(
						"success",
						response.message
					);
					this.initTestTool();
					tempSubscription.unsubscribe();
				});
		}
	}

	enableRevertButton() {
		let besideStorage = this.testTool["last_to_by_type"] != "storage";

		return this.revertPermission && this.testTool.id > 0 && besideStorage;
	}
}
